import { OrderStatus } from '../../api';
import { createFilterContext } from '../../common/filter/createFilterContext';

export const ALL_ORDER_STATUSES: OrderStatus[] = [
  OrderStatus.REQUESTED,
  OrderStatus.PAID,
  OrderStatus.CONFIRMED,
  OrderStatus.PAID_WITH_VOUCHER,
  OrderStatus.CONVERTED_TO_VOUCHER,
  OrderStatus.CONVERTED_FROM_VOUCHER,
  OrderStatus.PAYMENT_LINK_GENERATED,
  OrderStatus.CONVERTED_FROM_WAITLIST,
  OrderStatus.PAID_WITH_PAYMENT_LINK,
  OrderStatus.PAID_WITH_PASS,
  OrderStatus.PAID_WITH_EXTERNAL_VOUCHER,
  OrderStatus.DEPOSIT_PAID,
  OrderStatus.ABANDONED,
  OrderStatus.ARCHIVED,
];

type OrdersFilterState = {
  selectedOrderPageIds: string[] | null;
  statuses: OrderStatus[];
};

const DEFAULTS: OrdersFilterState = {
  selectedOrderPageIds: null,
  statuses: ALL_ORDER_STATUSES,
};

const { Provider: OrdersFilterProvider, useBaseFilter } = createFilterContext<OrdersFilterState>({
  storageKey: 'webook-orders-filter',
  defaults: DEFAULTS,
  isActive: (s) => s.selectedOrderPageIds !== null || s.statuses.length !== ALL_ORDER_STATUSES.length,
});

export { OrdersFilterProvider };

export const useOrdersFilter = () => {
  const { state, setState, isActive, reset } = useBaseFilter();
  return {
    selectedOrderPageIds: state.selectedOrderPageIds,
    setSelectedOrderPageIds: (v: string[] | null) => setState({ selectedOrderPageIds: v }),
    statuses: state.statuses,
    setStatuses: (v: OrderStatus[]) => setState({ statuses: v }),
    isFilterActive: isActive,
    resetFilter: reset,
  };
};
